/* ESP Editor Form block (EDITOR-67), snippets/esp-editor-form.liquid. Hand-written ES2019, no build; loaded with
   defer by each form, run once. The same behaviour as PageForm.tsx on the new site: every field is checked when
   sent, with a list of what to fix; photos are redrawn smaller in the browser (which drops their location data) and
   sent with fetch to ESP Editor's address; then "Request received" takes the form's place. Each send carries a
   Cloudflare Turnstile token (EDITOR-68), which ESP Editor checks with Cloudflare; the check stays out of sight
   unless Cloudflare asks the person to tick it. Without this script the form posts as it is (no token) and the server
   sends the browser back to #<key>-error, which gives the support address. */
(()=>{
'use strict';
const win=window,D=document;
if(win.espEdForm)return;
win.espEdForm=1;
const q=(e,s)=>e.querySelector(s),qa=(e,s)=>[].slice.call(e.querySelectorAll(s)),
 make=(tag,cls,text)=>{const e=D.createElement(tag);if(cls)e.className=cls;if(text!=null)e.textContent=text;return e;};
const EMAIL=/^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;
const ICON='<svg class="esp-ed-form__alert-icon" width="SIZE" height="SIZE" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5h.01"/></svg>';
const icon=n=>ICON.replace(/SIZE/g,String(n));
const sidOf=()=>win.crypto&&win.crypto.randomUUID?win.crypto.randomUUID():Date.now().toString(36)+'-'+Math.random().toString(36).slice(2);
// Cloudflare's Turnstile script, added once for the page; resolves null when it can't load (blocked, offline).
const TURNSTILE_JS='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=espEdTurnstileReady';
let turnstileLoading=null;
const loadTurnstile=()=>{
 if(win.turnstile)return Promise.resolve(win.turnstile);
 if(turnstileLoading)return turnstileLoading;
 turnstileLoading=new Promise(done=>{
  win.espEdTurnstileReady=()=>done(win.turnstile||null);
  const s=D.createElement('script');
  s.src=TURNSTILE_JS;s.async=true;
  s.onerror=()=>{turnstileLoading=null;done(null);};
  D.head.appendChild(s);
 });
 return turnstileLoading;
};
// How long a send waits for Turnstile's token before giving up.
const TOKEN_WAIT=15000;

const setup=box=>{
 const form=q(box,'form.esp-ed-form__body'),cfgEl=q(box,'.esp-ed-form__cfg');
 if(!form||!cfgEl||form.getAttribute('data-ready'))return;
 let cfg;
 try{cfg=JSON.parse(cfgEl.textContent);}catch(e){return;}
 form.setAttribute('data-ready','1');
 form.noValidate=true;
 const W=cfg.words,shown=win.performance?performance.now():Date.now(),sid=sidOf();
 const now=()=>win.performance?performance.now():Date.now();
 const alertBox=q(form,'.esp-ed-form__alert'),submit=q(form,'.esp-ed-form__submit'),note=q(form,'.esp-ed-form__note');
 const submitHtml=submit.innerHTML,noteText=note.textContent;
 const controls=qa(form,'[data-kind]'),photos={};
 const contact=q(box,'.esp-ed-form__nojs--error .esp-ed-form__link');
 // tried: a send was tried (messages follow typing from then on). failedNow: the last send didn't go through.
 // shownAs/listed: what the alert box holds now, so it is only rebuilt (and read out again) when that changes.
 let tried=false,sending=false,failedNow=false,shownAs='',listed='';

 // A field with data-by (EDITOR-78, EDITOR-81) follows another field's value (the brand): data-by-is gives, per value,
 // 'required', 'optional' or 'hidden'; '*' is any other value, '' nothing chosen, and a value not listed is hidden.
 // As lib/editor/forms.ts fieldNeed(). It is printed optional, for pages without this script.
 const own=(o,k)=>Object.prototype.hasOwnProperty.call(o,k)?o[k]:undefined;
 const pick=(table,name)=>{
  const c=form.elements.namedItem(name),v=c&&c.value!=null?String(c.value).trim():'';
  return own(table,v)||(v?own(table,'*'):undefined);
 };
 const rules=new Map();
 controls.forEach(el=>{
  if(!el.hasAttribute('data-by'))return;
  try{rules.set(el,JSON.parse(el.getAttribute('data-by-is')));}catch(e){rules.set(el,{});}
 });
 const needOf=el=>rules.has(el)?pick(rules.get(el),el.getAttribute('data-by'))||'hidden':el.required?'required':'optional';
 const applies=el=>needOf(el)!=='hidden';
 // The line saying what this choice needs (FormDef guide), shown only with this script.
 const guide=q(form,'.esp-ed-form__guide');
 let guideText={};
 if(guide)try{guideText=JSON.parse(guide.getAttribute('data-guide'));}catch(e){}
 // Each field's "(optional)", kept to put back when the choice makes the field optional again.
 const opts=new Map();
 rules.forEach((_,el)=>{const o=q(el.closest('.esp-ed-form__field'),'.esp-ed-form__opt');if(o)opts.set(el,o);});
 const sync=()=>{
  rules.forEach((_,el)=>{
   const need=needOf(el),field=el.closest('.esp-ed-form__field'),label=q(field,'.esp-ed-form__label'),o=opts.get(el);
   field.hidden=need==='hidden';
   el.required=need==='required';
   if(o&&need==='required'&&o.parentNode)o.parentNode.removeChild(o);
   if(o&&need==='optional'&&!o.parentNode&&label)label.appendChild(o);
  });
  // A row whose fields are all hidden goes too.
  qa(form,'.esp-ed-form__row').forEach(r=>{r.hidden=qa(r,'.esp-ed-form__field').every(f=>f.hidden);});
  if(guide){guide.textContent=pick(guideText,guide.getAttribute('data-guide-for'))||'';guide.hidden=false;}
 };
 // The fields that lead (the brand): a change shows, hides or changes what follows, and their messages follow too.
 const leaders=[];
 rules.forEach((_,el)=>{const n=el.getAttribute('data-by');if(leaders.indexOf(n)<0)leaders.push(n);});
 if(guide&&leaders.indexOf(guide.getAttribute('data-guide-for'))<0)leaders.push(guide.getAttribute('data-guide-for'));
 leaders.forEach(n=>{
  const c=form.elements.namedItem(n);
  if(c&&c.addEventListener)c.addEventListener('change',()=>{sync();rules.forEach((_,el)=>{if(el.getAttribute('data-by')===n)recheck(el);});});
 });

 // Checks: the same as lib/editor/forms.ts fieldProblem() on the new site.
 const problem=el=>{
  const need=needOf(el);
  if(need==='hidden')return '';
  const k=el.getAttribute('data-kind'),miss=el.getAttribute('data-missing')||'';
  if(k==='photo')return need==='required'&&!photos[el.name]?miss:'';
  const v=el.value.trim();
  if(!v)return need==='required'?miss:'';
  if(k==='email'&&(!EMAIL.test(v)||v.length>200))return W.badEmail;
  if(k==='tel'){const d=v.replace(/\D/g,'').length;if(d<10||d>15)return W.badPhone;}
  if(k==='select'&&!qa(el,'option').some(o=>o.value&&o.value===v))return miss;
  return '';
 };
 const errId=el=>el.id+'-err';
 const describe=(el,bad)=>{
  const k=el.getAttribute('data-kind'),ids=[];
  const mine=k==='photo'?el.id+'-drop':el.id+'-hint';
  if(D.getElementById(mine))ids.push(mine);
  // The brand: described by the line saying what it needs (EDITOR-81).
  if(guide&&guide.id===el.id+'-guide')ids.push(guide.id);
  if(bad)ids.push(errId(el));
  if(ids.length)el.setAttribute('aria-describedby',ids.join(' '));else el.removeAttribute('aria-describedby');
 };
 /** One field's message: under it (photos: under the photo group, in field order). */
 const show=(el,text)=>{
  const old=D.getElementById(errId(el));
  if(old)old.parentNode.removeChild(old);
  const photo=el.getAttribute('data-kind')==='photo',tile=photo?el.closest('.esp-ed-form__tile'):null;
  if(photo){if(tile)tile.classList.toggle('esp-ed-form__tile--bad',!!text);}
  else el.classList.toggle('esp-ed-form__input--bad',!!text);
  if(text)el.setAttribute('aria-invalid','true');else el.removeAttribute('aria-invalid');
  describe(el,!!text);
  if(!text)return;
  const p=make('p','esp-ed-form__error');
  p.id=errId(el);
  p.innerHTML=icon(16);
  p.appendChild(make('span','',text));
  if(photo){
   const set=el.closest('.esp-ed-form__photos'),strip=q(set,'.esp-ed-form__strip');
   // In field order: before the next photo's message, else before the note about location data.
   const later=controls.slice(controls.indexOf(el)+1).map(c=>D.getElementById(errId(c))).filter(x=>x&&x.parentNode===set)[0];
   set.insertBefore(p,later||strip);
  }else el.closest('.esp-ed-form__field').appendChild(p);
 };
 const jump=el=>{
  // A chosen photo's file field is hidden: its Remove button stands in for it.
  const target=el.getAttribute('data-kind')==='photo'&&photos[el.name]&&D.getElementById(el.id+'-remove')||el;
  const holder=target.closest('.esp-ed-form__field,.esp-ed-form__tile,.esp-ed-form__chosen')||target;
  if(holder.scrollIntoView)holder.scrollIntoView({block:'center'});
  target.focus({preventScroll:true});
 };
 const alertWith=(nodes,quiet)=>{
  alertBox.innerHTML='';
  nodes.forEach(n=>alertBox.appendChild(n));
  alertBox.hidden=false;
  if(quiet)return;
  if(alertBox.scrollIntoView)alertBox.scrollIntoView({block:'center'});
  alertBox.focus({preventScroll:true});
 };
 /** The fields' messages as shown, in field order. */
 const shownProblems=()=>controls.map(el=>{const e=D.getElementById(errId(el));return e?{el,text:e.textContent}:null;}).filter(Boolean);
 /**
  * The alert box, as PageForm.tsx draws it: once a send was tried, the list of what to fix (it follows the fields'
  * messages); else, after a send that didn't go through, the failed message; else nothing. `quiet` keeps focus where
  * it is (a field changed); a send moves focus to the box.
  */
 const paint=quiet=>{
  const found=tried?shownProblems():[];
  if(found.length){
   const key=found.map(f=>f.el.name+'='+f.text).join('|');
   if(quiet&&shownAs==='list'&&key===listed)return;
   shownAs='list';listed=key;
   const title=make('p','esp-ed-form__alert-title');
   title.innerHTML=icon(20);
   title.appendChild(make('span','',found.length===1?W.fixOne:found.length+' '+W.fixMany));
   const ul=make('ul','esp-ed-form__alert-list');
   found.forEach(f=>{
    const li=make('li'),b=make('button','esp-ed-form__jump',f.text);
    b.type='button';
    b.addEventListener('click',()=>jump(f.el));
    li.appendChild(b);
    ul.appendChild(li);
   });
   alertWith([title,ul],quiet);
  }else if(failedNow){
   if(quiet&&shownAs==='failed')return;
   shownAs='failed';listed='';
   const title=make('p','esp-ed-form__alert-title');
   title.innerHTML=icon(20);
   const span=make('span','',W.failed+' ');
   if(contact)span.appendChild(contact.cloneNode(true));
   span.appendChild(D.createTextNode('.'));
   title.appendChild(span);
   alertWith([title],quiet);
  }else{
   shownAs='';listed='';
   alertBox.hidden=true;
   alertBox.innerHTML='';
  }
 };
 const failed=()=>{
  sendingState(false);
  failedNow=true;
  paint(false);
 };
 const sendingState=on=>{
  sending=on;
  submit.disabled=on;
  if(on){submit.innerHTML='<span class="esp-ed-form__spin" aria-hidden="true"></span>';submit.appendChild(D.createTextNode(W.sending));}
  else submit.innerHTML=submitHtml;
  note.textContent=on?W.sendingNote:noteText;
  if(on)form.setAttribute('aria-busy','true');else form.removeAttribute('aria-busy');
 };
 const recheck=el=>{if(tried){show(el,problem(el));paint(true);}};

 // Turnstile (as PageForm.tsx): state is 'loading' (getting a token), 'ready' (has one), 'interactive' (Cloudflare
 // wants the person to tick it) or 'error' (blocked or failed). No site key: no check (then the forms can't send).
 const checkBox=q(form,'.esp-ed-form__check');
 let widget=null,token='',checkState=cfg.turnstile&&checkBox?'loading':'off',waiters=[];
 const noteCheck=on=>{note.textContent=on?W.robotCheck:noteText;note.classList.toggle('esp-ed-form__note--check',on);};
 const settle=(state,t)=>{
  checkState=state;token=t||'';
  // Once Cloudflare asks the person, the check stays in view (with its tick) until the next reset.
  if(state==='interactive')checkBox.classList.add('esp-ed-form__check--shown');
  // A send waiting for the token goes on with it; a check that needs the person (or can't work) stops it.
  if(state!=='loading')waiters.splice(0).forEach(w=>w(token));
  if(state==='ready'&&!sending)noteCheck(false);
 };
 if(checkState==='loading')loadTurnstile().then(api=>{
  if(!api)return settle('error');
  try{
   const id=api.render(checkBox,{
    sitekey:cfg.turnstile,action:cfg.form,appearance:'interaction-only',size:'flexible',theme:'light',
    'response-field':false,'refresh-expired':'auto',
    callback:t=>settle('ready',t),
    'expired-callback':()=>settle('loading'),
    'before-interactive-callback':()=>settle('interactive'),
    'after-interactive-callback':()=>settle('loading'),
    'timeout-callback':()=>settle('interactive'),
    'unsupported-callback':()=>settle('error'),
    // Returning true tells Turnstile the error is handled (it retries by itself where it can).
    'error-callback':()=>{settle('error');return true;}
   });
   if(id)widget={api,id};else settle('error');
  }catch(e){settle('error');}
 });
 /** The token for this send: at once if there is one, else when Turnstile has it; '' if it needs the person or failed. */
 const tokenSoon=()=>new Promise(done=>{
  if(checkState==='off'||token)return done(token);
  if(checkState==='interactive'||checkState==='error')return done('');
  let timer=0;
  const finish=t=>{clearTimeout(timer);waiters=waiters.filter(w=>w!==finish);done(t);};
  timer=setTimeout(()=>finish(''),TOKEN_WAIT);
  waiters.push(finish);
 });
 /** A token works once: after any send that didn't go through, Turnstile makes a new one. */
 const freshToken=()=>{
  token='';
  if(!widget)return;
  checkState='loading';
  checkBox.classList.remove('esp-ed-form__check--shown');
  try{widget.api.reset(widget.id);}catch(e){checkState='error';}
 };

 // Photos: a smaller JPEG drawn in the browser, or the file itself when the browser can't draw it.
 const toJpeg=(img,w,h)=>new Promise(done=>{
  const s=Math.min(1,cfg.edge/Math.max(w,h)),c=D.createElement('canvas');
  c.width=Math.max(1,Math.round(w*s));c.height=Math.max(1,Math.round(h*s));
  const g=c.getContext('2d');
  if(!g||!c.toBlob)return done(null);
  g.fillStyle='#ffffff';g.fillRect(0,0,c.width,c.height);g.drawImage(img,0,0,c.width,c.height);
  c.toBlob(b=>done(b),'image/jpeg',0.85);
 });
 const drawn=file=>win.createImageBitmap
  ?createImageBitmap(file,{imageOrientation:'from-image'}).then(bm=>toJpeg(bm,bm.width,bm.height).then(b=>{if(bm.close)bm.close();return b;}))
  :new Promise((done,fail)=>{const u=URL.createObjectURL(file),i=new Image();i.onload=()=>toJpeg(i,i.naturalWidth,i.naturalHeight).then(b=>{URL.revokeObjectURL(u);done(b);});i.onerror=()=>{URL.revokeObjectURL(u);fail();};i.src=u;});
 const asIs=file=>cfg.types.indexOf(file.type)<0?{problem:W.badPhoto}:file.size>cfg.max?{problem:W.bigPhoto}:{blob:file,name:file.name,url:URL.createObjectURL(file),smaller:false};
 const prepare=(file,name)=>drawn(file).then(b=>b?{blob:b,name:name+'.jpg',url:URL.createObjectURL(b),smaller:true}:asIs(file),()=>asIs(file));

 const strip=el=>{
  const set=el.closest('.esp-ed-form__photos');
  const any=qa(set,'.esp-ed-form__file').some(i=>photos[i.name]);
  q(set,'.esp-ed-form__strip').hidden=!any;
  q(set,'.esp-ed-form__tiles').classList.toggle('esp-ed-form__tiles--chosen',any);
 };
 const chosen=(el,photo)=>{
  const tile=el.closest('.esp-ed-form__tile'),row=make('div','esp-ed-form__chosen'),img=make('img','esp-ed-form__thumb');
  img.src=photo.url;img.alt='';img.width=88;img.height=88;
  const text=make('div','esp-ed-form__chosen-text');
  text.appendChild(make('p','esp-ed-form__tile-name',el.getAttribute('data-label')));
  text.appendChild(make('p','esp-ed-form__hint',photo.smaller?'Photo ready, made smaller to send':'Photo ready'));
  const rm=make('button','esp-ed-form__remove',W.remove);
  rm.type='button';
  rm.id=el.id+'-remove';
  rm.setAttribute('aria-label',W.remove+': '+el.getAttribute('data-label'));
  rm.addEventListener('click',()=>{
   URL.revokeObjectURL(photo.url);
   delete photos[el.name];
   row.parentNode.removeChild(row);
   tile.hidden=false;
   strip(el);
   recheck(el);
   el.focus();
  });
  row.appendChild(img);row.appendChild(text);row.appendChild(rm);
  tile.hidden=true;
  tile.parentNode.insertBefore(row,tile.nextSibling);
 };
 const take=(el,file)=>{
  if(!file)return;
  prepare(file,el.name).then(r=>{
   if(r.problem){show(el,r.problem);paint(true);return;}
   if(photos[el.name])URL.revokeObjectURL(photos[el.name].url);
   photos[el.name]=r;
   chosen(el,r);
   show(el,'');
   strip(el);
   paint(true);
  });
 };

 controls.forEach(el=>{
  if(el.getAttribute('data-kind')==='photo'){
   const tile=el.closest('.esp-ed-form__tile');
   el.addEventListener('change',()=>{const f=el.files&&el.files[0];el.value='';take(el,f);});
   tile.addEventListener('dragover',e=>{e.preventDefault();tile.classList.add('esp-ed-form__tile--over');});
   tile.addEventListener('dragleave',()=>tile.classList.remove('esp-ed-form__tile--over'));
   tile.addEventListener('drop',e=>{e.preventDefault();tile.classList.remove('esp-ed-form__tile--over');take(el,e.dataTransfer&&e.dataTransfer.files[0]);});
  }else{
   el.addEventListener('input',()=>recheck(el));
   el.addEventListener('change',()=>recheck(el));
  }
 });

 // The fields as the choice so far says (nothing chosen yet, or what the browser kept), and the brand's description.
 sync();
 if(guide){const c=form.elements.namedItem(guide.getAttribute('data-guide-for'));if(c&&c.id)describe(c,false);}

 const sent=()=>{
  const done=q(box,'.esp-ed-form__nojs--sent'),err=q(box,'.esp-ed-form__nojs--error');
  Object.keys(photos).forEach(k=>URL.revokeObjectURL(photos[k].url));
  done.classList.remove('esp-ed-form__nojs');
  if(err)err.parentNode.removeChild(err);
  form.parentNode.removeChild(form);
  box.classList.add('esp-ed-form--sent');
  box.setAttribute('role','status');
  const h=q(done,'.esp-ed-form__title');
  if(h)h.focus();
 };

 form.addEventListener('submit',e=>{
  e.preventDefault();
  if(sending)return;
  tried=true;
  failedNow=false;
  controls.forEach(el=>show(el,problem(el)));
  if(shownProblems().length)return paint(false);
  paint(true);
  noteCheck(false);
  sendingState(true);
  tokenSoon().then(t=>{
   if(checkState!=='off'&&!t){
    // Cloudflare wants the person to tick the check: say so by the button and bring the check into view.
    if(checkState==='interactive'){
     sendingState(false);
     noteCheck(true);
     if(checkBox.scrollIntoView)checkBox.scrollIntoView({block:'center'});
     return;
    }
    // Blocked or failed: the same message as a refusal, with the support address.
    return failed();
   }
   send(t);
  });
 });

 const send=t=>{
  const body=new FormData();
  controls.forEach(el=>{
   // A field that doesn't count with these answers isn't sent (the server would leave it out anyway).
   if(!applies(el))return;
   if(el.getAttribute('data-kind')==='photo'){const p=photos[el.name];if(p)body.append(el.name,p.blob,p.name);}
   else body.append(el.name,el.value.trim());
  });
  const trap=form.elements.namedItem('website');
  body.append('website',trap?trap.value:'');
  body.append('_sid',sid);
  body.append('_ms',String(Math.round(now()-shown)));
  body.append('_back',location.pathname);
  const block=form.elements.namedItem('_block');
  body.append('_block',block?block.value:'');
  if(t)body.append('cf-turnstile-response',t);
  fetch(form.getAttribute('action'),{method:'POST',body,headers:{Accept:'application/json'},credentials:'omit'})
   .then(r=>r.json().then(d=>({r,d}),()=>({r,d:null})))
   .then(x=>{
    if(x.r.ok&&x.d&&x.d.ok)return sent();
    freshToken();
    const fields=x.d&&x.d.fields;
    // The server read a field differently (it checks everything again): its words for those fields.
    if(x.r.status===400&&fields&&controls.some(el=>fields[el.name])){
     sendingState(false);
     controls.forEach(el=>show(el,fields[el.name]||''));
     return paint(false);
    }
    failed();
   })
   .catch(()=>{freshToken();failed();});
 };
};

const all=()=>qa(D,'.esp-ed-form').forEach(setup);
if(D.readyState==='loading')D.addEventListener('DOMContentLoaded',all);else all();
})();
